<template>
  <div class="invoiceCard" @click="viewInvoice()" :class="invoice.status">
    <div class="invoiceCardGrid">
      <div>
        <card-title :content="invoice.customer_email"></card-title>
        <span class="invoiceCardDescription" v-for="(item, key, i) in invoice.lines.data" :key="i">
          {{$options.filters.truncate(item.description, 28) | capitalize}}<span v-if="key < Object.keys(invoice.lines.data).length - 1">, </span>
        </span>
      </div>
      <div class="text-right">
        {{(invoice.amount_due / 100) | currency}}<br/>
        <!-- <span class="w3-text-light-grey">{{(invoice.amount_remaining / 100) | currency}}</span> -->
        <span class="w3-text-light-grey">{{(invoice.date) | date}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import dataStore from '@/dataStore';
import cardTitle from '@/system/atoms/cardTitle';

export default {
  name: 'invoice-card',
  data() {
    return {
      state: dataStore.state
    }
  },
  components: {
    'card-title': cardTitle
  },
  props: [
    'invoice'
  ],
  methods: {
    viewInvoice() {
      console.log('test')
      this.state.user.invoices.activeInvoice = this.invoice
      this.state.invoicesView = 'details'
    }
  }
}
</script>
<style>
  .invoiceCard {border: 1px solid #ccc; border-radius: 5px; padding: 16px; margin:0;}
  .invoiceCardDescription {color: #999;}

  .invoiceCardGrid {display: grid; grid-template-columns: 3fr 1fr; grid-gap: 10px;}
  .paid {border-right:2px solid green;}
  .uncollectible {border-right:2px solid red;}
  .void {border-right:2px solid orange;}
</style>


// WEBPACK FOOTER //
// src/system/molecules/invoiceCard.vue